/** Tuile Pilotage / permission BDD — distinct de « Emails » (Snappy). */
export const MAIL_SUITE_APP_TILE = "Email";

/** Nom affiché dans les modales SSO Suite. */
export const MAIL_APP_DISPLAY_NAME = "Email";

/** Titre en-tête app (aligné Coffre, Photos…). */
export const MAIL_APP_HEADER_TITLE = "Aurélia Mail";

export const MAIL_SESSION_VERIFIED_FLAG = "__mailSessionVerified";

export const MAIL_AUTH_READY_EVENT = "mailAuthReady";

export const MAIL_AUTH_LOST_EVENT = "mailAuthLost";

export const SUITE_SESSION_ERROR_CODES = new Set([
  "session_required",
  "session_or_userid_required",
  "unauthorized",
]);

export const SUITE_FORBIDDEN_ERROR_CODES = new Set([
  "app_not_permitted",
  "forbidden_app_permission",
  "no_active_client",
  "admin_apps_disabled",
]);
